import { createContext } from "react";

export const AuthContext = createContext(null);
export const ModalContext = createContext(null);
